var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4512 7.5C12.4512 10.2614 10.2126 12.5 7.45117 12.5C4.68975 12.5 2.45117 10.2614 2.45117 7.5C2.45117 4.73858 4.68975 2.5 7.45117 2.5C10.2126 2.5 12.4512 4.73858 12.4512 7.5ZM11.3528 12.0584C10.3038 12.9571 8.94087 13.5 7.45117 13.5C4.13746 13.5 1.45117 10.8137 1.45117 7.5C1.45117 4.18629 4.13746 1.5 7.45117 1.5C10.7649 1.5 13.4512 4.18629 13.4512 7.5C13.4512 8.96179 12.9284 10.3015 12.0597 11.3424L14.3573 13.1458C14.5746 13.3164 14.611 13.6294 14.4386 13.845C14.2662 14.0607 13.9503 14.0972 13.733 13.9267L11.3528 12.0584Z",
    fill: "#97A3B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.db7f315ee6d835bfee951dd65585f765.svg";
export { ForwardRef as ReactComponent };